(() => {
  const oldKeys = ['Ürün fiyat indirimi (1 adet)', 'Catalog price reduction (per item)'];
  const root = window.Shopify?.routes?.root || '/';
  let preparing = false;
  document.addEventListener('submit', async (event) => {
    if (event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (preparing) return;
    preparing = true;
    event.submitter.disabled = true;
    event.submitter.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}});
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      for (const item of cart.items) {
        if (!oldKeys.some((key) => Object.hasOwn(item.properties || {}, key))) continue;
        const properties = {...item.properties};
        oldKeys.forEach((key) => {delete properties[key];});
        const result = await fetch(root + 'cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({id: item.key, quantity: item.quantity, properties})});
        if (!result.ok) throw new Error('Cart unavailable');
      }
    } catch (error) {
      console.warn('Checkout details could not be refreshed', error);
    }
    window.location.assign(root + 'checkout');
  }, true);
})();
